import { render, staticRenderFns } from "./KitchenPreviewPage.vue?vue&type=template&id=81df521a&scoped=true&"
import script from "./KitchenPreviewPage.vue?vue&type=script&lang=js&"
export * from "./KitchenPreviewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81df521a",
  null
  
)

export default component.exports